module.exports = __webpack_public_path__ + "img/noimage-white.b648309e.png";